import React, { Component, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getList, showUpdate, showDelete } from './usuarioAction'
import ReactPaginate from 'react-paginate';
import Grid from '../common/layout/grid'

class UsuarioList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            tipoPesq: '', valorPesq: '', enableInputPesquisa: true, itensPorPag: 15, atualPage: 1,
            currentItems: [], pageCount: 0, itemOffset: 0
        }


    }

    componentWillMount() {
        this.props.getList()


    }

    getStatus(status) {
        return status ? 'Ativo' : 'Inativo'
    }

    renderRows() {
        if(this.props.list === undefined ) {return};
        var list = this.props.list.rows || []

        return list.map(bc => (
            <tr key={bc.id}>
                <td>{bc.nome} </td>
                <td>{bc.email} </td>
                <td >{this.getStatus(bc.ativo)} </td>
                <td>
                    <button className='btn btn-warning' onClick={() => this.props.showUpdate(bc)}>
                        <i className="fa fa-pencil"></i>
                    </button>
                    <button className='btn btn-danger' onClick={() => this.props.showDelete(bc)}>
                        <i className="fa fa-trash-o"></i>
                    </button>
                </td>
            </tr>
        ))
    }

    setItensPorPag = e => {
        this.setState({ ...this.state, itensPorPag: e.target.value })

    }

    setValorTipoPesquisa = e => {
        let tipoPesquisa = e.target.value
        if (tipoPesquisa === "") {
            this.setState({ ...this.state, tipoPesq: e.target.value, enableInputPesquisa: true, valorPesq: "" });
        } else {
            this.setState({ ...this.state, tipoPesq: e.target.value, enableInputPesquisa: false });
        }

    }

    setValorPesquisa = e => {
        this.setState({ ...this.state, valorPesq: e.target.value });
    }

    handlePageClick = async (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.state.itensPorPag);

        this.setState({ offset: offset }, () => {
          //this.loadCommentsFromServer();
          this.props.getList(this.state.tipoPesq, this.state.valorPesq,offset,this.state.itensPorPag)
        });
    };





    render() {

        return (
            <div>
                <div>
                    <div className="col-md-6">
                        <label>Pesquisa</label>
                        <div id="custom-search-input">
                            <div className="input-group col-md-12">
                                <span className="input-group-btn">
                                    <select className="btn btn-info btn-sm" id="tipo" name="tipo" onChange={this.setValorTipoPesquisa}>
                                        <option value="">Todos</option>
                                        <option value="nome" >Nome</option>
                                        <option value="email">E-mail</option>
                                    </select>

                                </span>
                                <div className="input-group col-md-12">
                                    <input type="text" className="form-control input-sm" placeholder="Buscar" value={this.state.valorPesq} onChange={this.setValorPesquisa} readOnly={this.state.enableInputPesquisa} />
                                    <span className="input-group-btn">
                                        <button className="btn btn-info btn-sm" type="button" onClick={() => this.props.getList(this.state.tipoPesq, this.state.valorPesq)}>
                                            <i className="glyphicon glyphicon-search"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>E-mail</th>
                                <th>Status</th>
                                <th className='table-actions'>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}

                        </tbody>
                        <tfoot>

                        </tfoot>
                    </table>

                </div>
                <hr />
                <div>

                    <ReactPaginate
                        previousLabel="Anterior"
                        nextLabel="Próximo"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount={this.props.list === undefined? 0 :  Math.ceil(this.props.list.count / this.state.itensPorPag)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                    />

                    <div className="div_right">
                        <label class="select-inline" for="qtdPorPag" >Qtd.Registro por Pág.
                            &nbsp;
                            <select id="qtdPorPag" onChange={this.setItensPorPag} className="mdb-select md-form colorful-select dropdown-primary">
                                <option value="15">15</option>
                                <option value="20" >20</option>
                                <option value="25">25</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                            </select>
                        </label>

                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => ({ list: state.usuario.list })
const mapDispatchToProps = dispath => bindActionCreators({ getList, showUpdate, showDelete }, dispath)
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioList)


// WEBPACK FOOTER //
// ./src/usuario/usuarioList.jsx